import Vue from 'vue'
import Component from 'vue-class-component'
import authStore from '@/store/auth/auth-store'
import feedStore from '@/store/feed/feed-store'

@Component({
  name: 'auth-header'
})
export default class AuthHeader extends Vue {
  protected isNavOpen = false;

  get isAuthenticated () { return authStore.isAuthenticated }

  protected login (): void {
    authStore.dispatchLogin()
  }

  protected openNav (): void {
    this.isNavOpen = !this.isNavOpen
  }

  protected viewMyStatements (): void {
    feedStore.dispatchViewMyStatements()
  }

  protected viewMyConvos (): void {
    feedStore.dispatchViewMyConvos()
  }

  protected newConvo (): void {
    feedStore.dispatchNewConvo()
  }

}
